// Angular
import { NgModule } from '@angular/core';

// Afidium
import { SmsTextGenerationService } from './sms-text-generation.service';

@NgModule({
    providers: [
        SmsTextGenerationService
    ]
})
export class SmsTextGenerationModule {}